import { useEffect } from 'react';

import { connect } from 'react-redux';
import { NavLink } from 'react-router-dom';
import { bindActionCreators } from 'redux';
import { getMobileOperatingSystem } from '../../../utils';


import { ArrowLeftOutlined } from '@ant-design/icons';
import { Spin } from 'antd';
import JoinClass from '../../../components/teach/JoinClass';
import { t } from '../../../languages';
import { cleanFlags, joinClass } from '../../../modules/user';
import './index.less';
import Step4 from '../../../components/User/Register/Step4';


const JoinToClass = ({ user, lang, isLoading, joinClass, saved, error, cleanFlags }) => {
  const isApple = getMobileOperatingSystem() === 'iOS';

  // Equivalente a componentDidMount
  useEffect(() => {
    window.scrollTo(0, 0);
    cleanFlags();

    return () => {
      // Equivalente a componentWillUnmount
      cleanFlags();
    }
  }, []);

  const handleSave = ({ classCode, name, rejoin }) => {
    // console.log('handleSave: classCode:', classCode, 'name:', name, 'rejoin:', rejoin, 'lang:', lang);
    joinClass(classCode, name, rejoin, lang);
  };

  if (user) {
    // Se redirige en App
    return <Step4
      lang={lang}
      user={user}
    />;
  } else {
    return (
      <div className={`MiSoroban ${isApple ? 'apple-welcome' : ''}`}>
        <div className='mis-wrapper'>
          <section className="classes">
            <div className={`login-title ${isApple ? `apple-header` : ''}`}>
              <img src="./static/logo_mis.png" alt="" />
            </div>
            {isLoading ? <Spin size="large" className="spinner" /> : null}

            <article className='join-class'>
              <h2>{t(lang, 'joinClass')}</h2>

              {error ? <div className="error">{t(lang, error === 423 ? 'maxNStudentsReached' : 'correctErrors')}</div> : null}
              <JoinClass
                lang={lang}
                onJoin={(code, name, rejoin) => handleSave(code, name, rejoin)}
                onCancel={() => {
                  cleanFlags();
                }}
                error={error}
              />

              <br />
              <br />

              <NavLink to='/wellcome'>
                <h4 className="create-profile"><ArrowLeftOutlined /> {t(lang, 'beginning')}</h4>
              </NavLink>

            </article>
          </section>
        </div>
      </div>
    );
  }
};

const mapStateToProps = ({ user }) => ({
  user: user.user,
  isLoading: user.isLoading,
  saved: user.saved,
  error: user.error,
  lang: user.lang
});

const mapDispatchToProps = dispatch =>
  bindActionCreators({
    cleanFlags,
    joinClass
  }, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(JoinToClass);
